import React, { useEffect, useState } from "react";

import endpoint from "../../../config/endpoints";
import { apiGet } from "../../../utils/api_service";

export default function RoleWiseContainer() {
  const [data, setData] = useState([
    {
      name: "ASM",
      count: 28,
      color: "#7C6FE0",
    },

    {
      name: "RSM",
      count: 18,
      color: "#3B82F6",
    },

    {
      name: "SO",
      count: 56,
      color: "#10B981",
    },

    {
      name: "SR",
      count: 74,
      color: "#84CC16",
    },

    {
      name: "TSI",
      count: 46,
      color: "#F59E0B",
    },

    {
      name: "Distributor Salesman",
      count: 62,
      color: "#F97316",
    },
  ]);

  const [loading, setLoading] = useState(true);

  /* -------------------------------------------------------------------------- */
  /* API */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const timer = setTimeout(() => {
      apiGet({
        url:
          endpoint.outletBillHeader +
          "/packaging-type-wise-by-region?year=2026&month=05&regionId=",
      })
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  const totalRoles = data.reduce((a, b) => a + b.count, 0);

  return (
    <>
      {/* -------------------------------------------------------------------------- */}
      {/* STYLES */}
      {/* -------------------------------------------------------------------------- */}

      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -400px 0;
            }

            100% {
              background-position: 400px 0;
            }
          }

          @keyframes bubbleFloat1 {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-10px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          @keyframes bubbleFloat2 {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(8px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          @keyframes bubbleFloat3 {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-12px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          @keyframes miniBubble {
            0% {
              transform: translateY(0px) scale(1);
              opacity: 0.5;
            }

            50% {
              transform: translateY(-14px) scale(1.15);
              opacity: 1;
            }

            100% {
              transform: translateY(0px) scale(1);
              opacity: 0.5;
            }
          }

          @keyframes floatGlow {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-8px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          @media (max-width: 768px) {
            .dashboard-card {
              min-height: auto !important;
            }
          }
        `}
      </style>

      {/* -------------------------------------------------------------------------- */}
      {/* HEADER */}
      {/* -------------------------------------------------------------------------- */}

      <SectionHeader icon="🏗️" title="Role-wise Count" />

      {/* -------------------------------------------------------------------------- */}
      {/* MAIN GRID */}
      {/* -------------------------------------------------------------------------- */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(340px, 1fr))",
          gap: 20,
          width: "100%",
          alignItems: "stretch",
        }}
      >
        {/* -------------------------------------------------------------------------- */}
        {/* CARD 1 */}
        {/* -------------------------------------------------------------------------- */}

        <div
          className="dashboard-card"
          style={{
            background: "#fff",
            border: "1px solid #E2E8F0",
            borderRadius: 14,
            padding: 20,
            minHeight: 420,
            height: "100%",
            boxShadow: "0 2px 10px rgba(15,23,42,0.04)",
            overflow: "hidden",
          }}
        >
          {/* Header */}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 10,
              paddingBottom: 8,
              borderBottom: "1px solid #F1F5F9",
            }}
          >
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                color: "#94A3B8",
              }}
            >
              Role
            </span>

            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                color: "#94A3B8",
              }}
            >
              Count
            </span>
          </div>

          {/* Role Bars */}

          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
              <SkeletonRoleBar key={index} />
            ))
            : data.map((r) => (
              <RoleBar
                key={r.name}
                name={r.name}
                count={r.count}
                color={r.color}
                max={totalRoles}
              />
            ))}

          {/* Footer */}

          {!loading && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
                paddingTop: 8,
                borderTop: "1px solid #F1F5F9",
              }}
            >
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#475569",
                }}
              >
                Total: {totalRoles} employees
              </span>
            </div>
          )}
        </div>

        {/* -------------------------------------------------------------------------- */}
        {/* CARD 2 */}
        {/* -------------------------------------------------------------------------- */}

        <div
          className="dashboard-card"
          style={{
            background: "#fff",
            border: "1px solid #E2E8F0",
            borderRadius: 14,
            padding: 20,
            minHeight: 420,
            height: "100%",
            boxShadow: "0 2px 10px rgba(15,23,42,0.04)",
            overflow: "hidden",
          }}
        >
          {loading ? (
            <SkeletonActivityCard />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#334155",
                  }}
                >
                  Activity
                </h3>

                <span
                  style={{
                    color: "#94A3B8",
                    fontWeight: 700,
                  }}
                >
                  ⋮
                </span>
              </div>

              {/* Bubble Area */}

              <div
                style={{
                  position: "relative",
                  minHeight: 240,
                  height: "clamp(240px, 35vw, 300px)",
                  overflow: "hidden",
                }}
              >
                {/* Glow */}

                <div
                  style={{
                    position: "absolute",
                    width: 260,
                    height: 260,
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(109,94,244,0.12), transparent 70%)",
                    top: 10,
                    left: 20,
                    animation: "floatGlow 6s ease-in-out infinite",
                  }}
                />

                {/* Bubble 1 */}

                <div
                  style={{
                    width: "clamp(100px, 10vw, 140px)",
                    height: "clamp(100px, 10vw, 140px)",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg,#7C6FE0 0%, #5B4DF5 100%)",
                    position: "absolute",
                    left: "4%",
                    top: "4%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    boxShadow: "0 12px 30px rgba(109,94,244,0.35)",
                    animation: "bubbleFloat1 5s ease-in-out infinite",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: 45,
                      height: 18,
                      borderRadius: 20,
                      background: "rgba(255,255,255,0.25)",
                      top: 22,
                      left: 28,
                      transform: "rotate(-20deg)",
                    }}
                  />

                  <div
                    style={{
                      fontSize: "clamp(18px, 2vw, 26px)",
                      fontWeight: 700,
                    }}
                  >
                    53,485
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                    }}
                  >
                    Sales
                  </div>
                </div>

                {/* Bubble 2 */}

                <div
                  style={{
                    width: "clamp(70px, 8vw, 95px)",
                    height: "clamp(70px, 8vw, 95px)",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg,#FF6B7C 0%, #FF4D67 100%)",
                    position: "absolute",
                    right: "5%",
                    top: "18%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    boxShadow: "0 12px 30px rgba(255,91,110,0.35)",
                    animation: "bubbleFloat2 4s ease-in-out infinite",
                  }}
                >
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 700,
                    }}
                  >
                    702
                  </div>

                  <div
                    style={{
                      fontSize: 11,
                    }}
                  >
                    Orders
                  </div>
                </div>

                {/* Bubble 3 */}

                <div
                  style={{
                    width: "clamp(85px, 9vw, 115px)",
                    height: "clamp(85px, 9vw, 115px)",
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg,#12D6B0 0%, #0EAF92 100%)",
                    position: "absolute",
                    bottom: "4%",
                    left: "32%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#fff",
                    boxShadow: "0 12px 30px rgba(16,201,167,0.35)",
                    animation: "bubbleFloat3 6s ease-in-out infinite",
                  }}
                >
                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: 700,
                    }}
                  >
                    17.30
                  </div>

                  <div
                    style={{
                      fontSize: 12,
                    }}
                  >
                    Revenue
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        {/* -------------------------------------------------------------------------- */}
        {/* CARD 3 */}
        {/* -------------------------------------------------------------------------- */}

        <div
          className="dashboard-card"
          style={{
            background: "#fff",
            border: "1px solid #E2E8F0",
            borderRadius: 14,
            padding: 20,
            minHeight: 420,
            height: "100%",
            boxShadow: "0 2px 10px rgba(15,23,42,0.04)",
            overflow: "hidden",
          }}
        >
          {loading ? (
            <SkeletonOverviewCard />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 24,
                  alignItems: "center",
                }}
              >
                <h3
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#334155",
                  }}
                >
                  Avg Time Spent On App
                </h3>

                <span
                  style={{
                    color: "#94A3B8",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  ⋮
                </span>
              </div>

              {/* Bar Chart */}

              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  gap: 14,
                  height: 280,
                  paddingTop: 20,
                  paddingBottom: 10,
                }}
              >
                <BarItem role="ASM" hours="6.2h" value={82} color="#7C6FE0" />

                <BarItem role="RSM" hours="5.1h" value={68} color="#3B82F6" />

                <BarItem role="SO" hours="7.0h" value={92} color="#10B981" />

                <BarItem role="SR" hours="4.3h" value={56} color="#F97316" />

                <BarItem role="TSI" hours="6.5h" value={86} color="#F59E0B" />

                <BarItem role="DS" hours="3.8h" value={42} color="#EF4444" />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

/* -------------------------------------------------------------------------- */
/* ROLE BAR */
/* -------------------------------------------------------------------------- */

function RoleBar({ name, count, color, max }) {
  const [progress, setProgress] = useState(0);

  const pct = Math.round((count / max) * 100);

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgress(pct);
    }, Math.random() * 400);

    return () => clearTimeout(timer);
  }, [pct]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 0",
        borderBottom: "1px solid #F1F5F9",
      }}
    >
      <span
        style={{
          width: "clamp(90px, 10vw, 130px)",
          fontSize: 13,
          fontWeight: 600,
          color: "#334155",
          flexShrink: 0,
        }}
      >
        {name}
      </span>

      <div
        style={{
          flex: 1,
          height: 8,
          background: "#F1F5F9",
          borderRadius: 99,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            background: color,
            borderRadius: 99,
            transition: "width 1.2s cubic-bezier(0.4,0,0.2,1)",
          }}
        />
      </div>

      <span
        style={{
          minWidth: 36,
          fontSize: 13,
          fontWeight: 700,
          textAlign: "right",
          color,
          background: color + "18",
          padding: "2px 8px",
          borderRadius: 6,
        }}
      >
        {count}
      </span>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* OVERVIEW ITEM */
/* -------------------------------------------------------------------------- */

function OverviewItem({ value, label, progress, color }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <div
        style={{
          width: 58,
          height: 58,
          borderRadius: "50%",
          border: `6px solid ${color}`,
          borderTopColor: "#E2E8F0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 700,
          color,
        }}
      >
        {progress}%
      </div>

      <div>
        <div
          style={{
            fontSize: "clamp(18px, 2vw, 22px)",
            fontWeight: 700,
            color: "#0F172A",
          }}
        >
          {value}
        </div>

        <div
          style={{
            fontSize: 13,
            color: "#94A3B8",
          }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}

/* -------------------------------------------------------------------------- */

function BarItem({ role, hours, value, color }) {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHeight(value);
    }, 200);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-end",
        height: "100%",
      }}
    >
      {/* Hours */}

      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: "#64748B",
          marginBottom: 10,
        }}
      >
        {hours}
      </span>

      {/* Bar */}

      <div
        style={{
          width: "100%",
          maxWidth: 38,
          height: "100%",
          background: "#EEF2F7",
          borderRadius: 999,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <div
          style={{
            width: "100%",
            height: `${height}%`,
            borderRadius: 999,
            background: `linear-gradient(180deg, ${color}, ${color}CC)`,
            transition: "height 1.4s cubic-bezier(0.4,0,0.2,1)",
            boxShadow: `0 0 14px ${color}55`,
            position: "relative",
          }}
        >
          {/* Glow */}

          <div
            style={{
              position: "absolute",
              top: 8,
              left: "50%",
              transform: "translateX(-50%)",
              width: "55%",
              height: 10,
              borderRadius: 20,
              background: "rgba(255,255,255,0.35)",
            }}
          />
        </div>
      </div>

      {/* Role */}

      <span
        style={{
          marginTop: 10,
          fontSize: 12,
          fontWeight: 700,
          color: "#334155",
        }}
      >
        {role}
      </span>
    </div>
  );
}
/* SECTION HEADER */
/* -------------------------------------------------------------------------- */

function SectionHeader({ icon, title }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 14,
        marginTop: 32,
        paddingBottom: 10,
        borderBottom: "1.5px solid #F1F5F9",
      }}
    >
      <span style={{ fontSize: 20 }}>{icon}</span>

      <span
        style={{
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#475569",
        }}
      >
        {title}
      </span>
    </div>
  );
}

/* -------------------------------------------------------------------------- */
/* SKELETONS */
/* -------------------------------------------------------------------------- */

function SkeletonRoleBar() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 0",
      }}
    >
      <SkeletonBox width={120} height={14} />
      <SkeletonBox width="100%" height={10} />
      <SkeletonBox width={40} height={24} />
    </div>
  );
}

function SkeletonActivityCard() {
  return <SkeletonBox width="100%" height={300} radius={20} />;
}

function SkeletonOverviewCard() {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        gap: 20,
      }}
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <SkeletonBox key={index} width="100%" height={80} radius={14} />
      ))}
    </div>
  );
}

function SkeletonBox({ width, height, radius = 6 }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background:
          "linear-gradient(90deg,#E2E8F0 25%,#F8FAFC 50%,#E2E8F0 75%)",
        backgroundSize: "800px 100%",
        animation: "shimmer 1.5s infinite linear",
      }}
    />
  );
}
